import { render, staticRenderFns } from "./CollapseMenu.vue?vue&type=template&id=3a7187ca"
import script from "./CollapseMenu.vue?vue&type=script&lang=js"
export * from "./CollapseMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports